const DeviceBlocked = () => {
  // Empty content, just use footer
  return <></>;
};

export default DeviceBlocked;
